export type CertificateEventDateMode = "start" | "end" | "range";

/**
 * Resolve which date(s) to print on a certificate based on the producer's
 * chosen mode. "range" collapses to a single date when start/end fall on
 * the same day, since printing "01/01 até 01/01" reads as a bug to the buyer.
 */
export function formatCertificateEventDate(
  startDateIso: string | null | undefined,
  endDateIso: string | null | undefined,
  mode: CertificateEventDateMode | undefined,
  formatFn: (date: Date) => string,
): string {
  const start = startDateIso ? new Date(startDateIso) : null;
  const end = endDateIso ? new Date(endDateIso) : null;

  if (mode === "end") {
    const target = end || start;
    return target ? formatFn(target) : "";
  }

  if (mode === "range") {
    if (start && end && start.toDateString() !== end.toDateString()) {
      return `${formatFn(start)} até ${formatFn(end)}`;
    }
    return start ? formatFn(start) : end ? formatFn(end) : "";
  }

  return start ? formatFn(start) : "";
}
